export default __webpack_public_path__ + "static/media/book-a-shoot.8c40f220.webp";